import { Fragment, useState } from "react";
import { Grid, Typography } from "@mui/material";

import List from "./List";
import { colors } from "../../css components/Style";
import AddNewAgentDialog from "./AddNewAgentDialog";
import { PageHeader, Paper } from "../../../components";
import { PrimaryButton } from "../../css components/Button";

export default function Form({ setColumns, setAgents, columns, agents }) {
  const [dialogState, setDialogState] = useState({ state: false, data: {} });

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageHeader
            title="Delivery Channel Settings"
            pageName={"Delivery Channel Settings"}
            pageHeader="Manage your delivery channel accounts"
            buttons={[
              <PrimaryButton
                variant="contained"
                onClick={() =>
                  setDialogState({ state: true, agents: agents, create: true })
                }
              >
                Add New Account
              </PrimaryButton>,
            ]}
          />
        </Grid>

        {agents?.map((agent) => (
          <Grid item xs={12} key={agent.channelID}>
            <Paper>
              <Grid item xs={12}>
                <Typography color={colors.primaryButton} variant="h6">
                  {agent.channelName}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <List
                  name={agent.channelName}
                  agent={agent[agent.channelName]}
                  fields={columns[agent.channelID]}
                  setDialogState={setDialogState}
                />
              </Grid>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <AddNewAgentDialog
        setColumns={setColumns}
        setAgents={setAgents}
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    </Fragment>
  );
}
